export const AMPLITUDE_EVENTS = {
  SSAI_LIVE_MODE_ENABLED: 'ssai live mode enabled',
  SSAI_LIVE_MODE_DISABLED: 'ssai live mode disabled',
  SSAI_PROACTIVE_OUTREACH_ENABLED: 'ssai proactive outreach enabled',
  SSAI_PROACTIVE_OUTREACH_DISABLED: 'ssai proactive outreach disabled',
};

export const SHOPPER_CONFIG_BASE_PATH = '/brand/shopper';
export const SHOPPER_AGENT_DEBUG_PATH = '/brand/shopper-debug';
export const SHOPPER_OUTREACH_MESSAGES_PATH = `${SHOPPER_CONFIG_BASE_PATH}/outreach-messages`;
export const SHOPPER_DEBUG_PATH = `${SHOPPER_CONFIG_BASE_PATH}/debug`;
export const SHOPPER_DEMO_KEYWORD = 'SHOPPERDEMO';

export const SHOPPER_WELCOME_MODAL_ACKNOWLEDGE_KEY =
  'shopperWelcomeAcknowledged';

export const GET_SHOPPER_PROMPT_OVERRIDES_QUERY_KEY =
  'shopper_get_prompt_overrides';
export const GET_SHOPPER_CONFIG_QUERY_KEY = 'shopper_get_config';
export const GET_SHOPPER_DEBUG_ACTIVE_PROMPTS =
  'get_shopper_debug_active_prompts';
export const GET_SHOPPER_DEBUG_CONTEXT_RESOLVER_DEFINITIONS =
  'get_shopper_debug_context_resolver_definitions';

export const SHOPPER_GRADIENT =
  'linear-gradient(102.79deg,#17161a 16.91%, #0f3e66 42.45%, #0b4855 64.57%, #162424 87.18%);';

export const SHOPIFY_OFFER_DETAILS_PLACEHOLDER_CONTENT =
  'Customers will receive an [X]% discount when they use the code';
export const FONDUE_OFFER_DETAILS_PLACEHOLDER_CONTENT =
  'Customers must use the link to make a purchase to receive [X]% CashBack.';

/* Ensure this is kept algined with pydantic on the API */
export const JSON_SCHEMA_VERSION = '2020-12';

export const GPT_4O_MAX_TOKENS = 128_000;

export const FREEPLAY_PROMPT_OVERRIDES_URL =
  'https://app.freeplay.ai/projects/ce4a3bb3-9c4e-4336-bfbc-c6ceadb15c7e/templates';

export const DEFAULT_SHOPPER_AGENT_PROMPT_NAME = 'Shopper Agent';

export const SHOP_PROMPT_OVERRIDES_PATH =
  '/v2/ai-components/prompts/shop-overrides/shop-prompt-overrides';
